<template>
  <div class="modal-overlay" @click.self="close">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="mb-0">Editar produto</h5>
        <div role="button" class="btn-close" @click="close"></div>
      </div>

      <div class="modal-body">
        <error-component :errors="errors" v-if="showError" />

        <div class="d-flex flex-column flex-lg-row gap-3">
          <img class="product-photo" v-if="itemData.photo" :src="itemData.photo" alt="" />
          <img class="product-photo" v-else src="@/assets/avatar.png" alt="" />

          <div class="w-100">
            <row-component>
              <col-component class-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                <label>Código:</label>
                <input-component :model-value="itemData.ref" disabled />
              </col-component>

              <col-component class-col="col-xxl-8 col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12">
                <label>Peça:</label>
                <input-component :model-value="itemData.name" disabled />
              </col-component>
            </row-component>

            <row-component>
              <col-component class-col="col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12">
                <label>Em estoque:</label>
                <input-component :model-value="itemData.in_stock" disabled />
              </col-component>

              <col-component class-col="col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12">
                <label>Quantidade:</label>
                <input-component v-model="formData.amount" type="number" @input="calculateTotal" />
              </col-component>

              <col-component class-col="col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12">
                <label>Preço UN:</label>
                <input-component v-model="formData.price" v-money="MONEY" @input="calculateTotal" />
              </col-component>

              <col-component class-col="col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12">
                <label>Preço total:</label>
                <input-component v-model="formData.price_total" v-money="MONEY" />
              </col-component>
            </row-component>

            <div class="text-end mt-3">
              <button-submit :disabled="sendForm" icon="save" name="Salvar" @click="submit" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RowComponent from '@/components/row/RowComponent.vue';
import ColComponent from '@/components/row/ColComponent.vue';
import InputComponent from '@/components/form/InputComponent.vue';
import ButtonSubmit from '@/components/buttons/ButtonSubmit.vue';
import ErrorComponent from '@/components/alerts/ErrorComponent.vue';
import { VMoney } from 'v-money';
import { MONEY } from '@/configs/constants';
import { useToast } from 'vue-toastification';

const toast = useToast();

export default {
  name: 'OrderPartEditProduct',

  components: {
    RowComponent,
    ColComponent,
    InputComponent,
    ButtonSubmit,
    ErrorComponent
  },

  directives: {
    money: VMoney
  },

  props: {
    itemData: {
      type: Object,
      required: true
    }
  },

  created() {
    this.formData.amount = this.itemData.amount;
    this.formData.price = this.itemData.price;
    this.formData.price_total = this.itemData.price_total;
  },

  data() {
    return {
      MONEY,
      formData: {
        amount: 1,
        price: '0,00',
        price_total: '0,00'
      },
      errors: [],
      showError: false,
      sendForm: false
    };
  },

  methods: {
    close() {
      this.$emit('close');
    },

    parseMoney(value) {
      if (!value) return 0;
      return Number(String(value).replace(/\./g, '').replace(',', '.').replace(/[^\d.-]/g, '')) || 0;
    },

    formatMoney(value) {
      return new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value || 0);
    },

    calculateTotal() {
      const total = Number(this.formData.amount || 0) * this.parseMoney(this.formData.price);
      this.formData.price_total = this.formatMoney(total);
    },

    submit() {
      if (this.sendForm) return;

      this.sendForm = true;
      const payload = {
        id: this.itemData.id,
        part_id: this.itemData.part_id || this.itemData.id,
        amount: this.formData.amount,
        price: this.formData.price,
        price_total: this.formData.price_total
      };

      this.$store
        .dispatch('updateOrderPartItem', payload)
        .then(() => {
          this.sendForm = false;
          toast.success('Produto atualizado com sucesso', { timeout: 1500 });
          this.$emit('saved');
          this.close();
        })
        .catch(e => {
          this.sendForm = false;
          this.showError = true;
          this.errors = e.response?.data?.errors || [];
          toast.error('Erro ao atualizar produto', { timeout: 1500 });
        });
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: #fff;
  padding: 20px;
  width: 1100px;
  max-width: 90%;
  position: relative;
  max-height: 80%;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.product-photo {
  width: 150px;
  height: 200px;
  object-fit: cover;
}
</style>
